import {
    EuiButton,
    EuiFieldNumber,
    EuiFlexGroup,
    EuiFlexItem,
    EuiFormRow,
    EuiSelect,
    EuiSuperSelect,
    EuiText,
    EuiCard,
    EuiSpacer,
    EuiComboBox,
} from '@elastic/eui';
import React, { useEffect, useState, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import ItemDetailsCollaspibleNav from './ItemDetailsCollaspibleNav';
import CheckBoxField from '../../../../../components/Form/CheckBoxField';
import TextField from '../../../../../components/Form/TextField';
import OrderingModePrices from '../../../../../components/menuComponentsRefactorCopy/menuEditorTab/OrderingModePrices';
import { ReactComponent as ItemPricingIcon } from '../../../../../assets/img/svg/ItemPricingIcon.svg';
import VariantModal from '../../../../../components/menuComponentsRefactorCopy/menuEditorTab/variantModal';

const gstOptions = [
    { value: '0.00', text: '0%' },
    { value: '5.00', text: '5%' },
    { value: '12.00', text: '12%' },
    { value: '18.00', text: '18%' },
    { value: '28.00', text: '28%' },
];

const ItemPricing = ({ variantConditionForPrice }) => {
    const {
        control,
        setValue,
        formState: { errors },
        watch,
    } = useFormContext();
    const [varaintModalState, setVaraintModalState] = useState(false);
    const allergens = useSelector((state) => state.menuReducer.allergens)?.filter(
        (allergen) => (allergen.label = allergen.internal_name)
    );
    const isOutletMenu = useSelector((state) => state.menuReducer.isOutletMenu);
    const quantityUnits = useSelector((state) => state.menuReducer.quantityUnits);
    const editItem = useSelector((state) => state.menuReducer.activeItemDetails.details);

    const [quantityIdOptions, setQuantityIdOptions] = useState([]);
    const [isNavOpen, setIsNavOpen] = useState(false);
    const themeMode = useSelector((state) => state.theme.theme);

    const priceRef = useRef(null);
    const comparePriceRef = useRef(null);
    const packagingPriceRef = useRef(null);

    useEffect(() => {
        if (quantityUnits?.length) {
            let units = [];
            for (const element of quantityUnits) {
                units.push({
                    value: element.id,
                    inputDisplay: element.unit,
                });
            }
            setQuantityIdOptions(units);
        }
    }, [quantityUnits]);

    const handleAllergensDeletion = (options) => {
        if (editItem?.ordering_modes?.[0]?.allergens?.length) {
            const removedAllergens = editItem.ordering_modes[0]?.allergens.filter(
                (allergen) => !options.some((option) => option.id === allergen.id)
            );

            for (let index = 0; index < editItem.ordering_modes.length; index++) {
                setValue(`ordering_modes[${index}].delete_allergens`, removedAllergens);
            }
        }
    };

    return (
        <>
            {varaintModalState && (
                <VariantModal
                    isOutletMenu={isOutletMenu}
                    setVaraintModalState={setVaraintModalState}
                    editItem={editItem}
                />
            )}

            <ItemDetailsCollaspibleNav
                cardTitle='Item Pricing'
                cardDescription={
                    watch('is_enabled_same_price_details_for_all_ordering_modes') ? (
                        <EuiText size='xs'>Active pricing ordering mode wise</EuiText>
                    ) : (
                        <EuiFlexGroup wrap alignItems='flexStart' justifyContent='spaceBetween' gutterSize='xs'>
                            <EuiFlexItem grow={false} style={{ minWidth: 100 }}>
                                {watch('price') >= 0 ? (
                                    <EuiText size='xs'>
                                        Price: <span>{watch('price')}</span>
                                    </EuiText>
                                ) : null}
                            </EuiFlexItem>
                            <EuiFlexItem grow={false} style={{ minWidth: 100 }}>
                                {watch('compare_price') >= 0 ? (
                                    <EuiText size='xs'>
                                        Compare Price: <span>{watch('compare_price')}</span>
                                    </EuiText>
                                ) : null}
                            </EuiFlexItem>
                            <EuiFlexItem grow={false} style={{ minWidth: 100 }}>
                                {watch('packaging_charge') >= 0 ? (
                                    <EuiText size='xs'>
                                        Packaging Charge: <span>{watch('packaging_charge')}</span>
                                    </EuiText>
                                ) : null}
                            </EuiFlexItem>
                            <EuiFlexItem grow={false} style={{ minWidth: 100 }}>
                                {watch('gst_slab') >= 0 ? (
                                    <EuiText size='xs'>
                                        GST: <span>{watch('gst_slab')}</span>
                                    </EuiText>
                                ) : null}
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    )
                }
                isNavOpen={isNavOpen}
                setIsNavOpen={setIsNavOpen}
                toggleText='Edit Item Pricing'
                icon={<ItemPricingIcon fill={themeMode === 'light' ? 'black' : 'white'} />}
            >
                <EuiFlexItem>
                    {variantConditionForPrice() ? (
                        <EuiFlexGroup
                            direction='column'
                            alignItems='flexStart'
                            justifyContent='flexStart'
                            gutterSize='s'
                        >
                            <EuiFlexItem>
                                <CheckBoxField
                                    name='is_enabled_same_price_details_for_all_ordering_modes'
                                    label='Different Price for all ordering mode?'
                                    control={control}
                                    setValue={setValue}
                                    isDisabled={isOutletMenu}
                                />
                            </EuiFlexItem>

                            <>
                                {watch('is_enabled_same_price_details_for_all_ordering_modes') ? (
                                    <>
                                        {watch('ordering_modes')?.length ? (
                                            watch('ordering_modes').map((orderingMode, index) => {
                                                return (
                                                    <OrderingModePrices
                                                        key={index}
                                                        index={index}
                                                        orderingMode={orderingMode}
                                                        errors={errors}
                                                        control={control}
                                                        priceRef={priceRef}
                                                        isOutletMenu={isOutletMenu}
                                                        comparePriceRef={comparePriceRef}
                                                        packagingPriceRef={packagingPriceRef}
                                                        gstOptions={gstOptions}
                                                        setValue={setValue}
                                                    />
                                                );
                                            })
                                        ) : (
                                            <>
                                                {/* This will be showen when client creates new item */}
                                                {watch('ordering_modes')?.length ? (
                                                    <>
                                                        {watch('ordering_modes').map((orderingMode, index) => {
                                                            return (
                                                                <EuiFlexItem
                                                                    component='div'
                                                                    key={orderingMode.id.toString()}
                                                                >
                                                                    {orderingMode.status ? (
                                                                        <>
                                                                            <OrderingModePrices
                                                                                key={index}
                                                                                index={index}
                                                                                orderingMode={orderingMode}
                                                                                errors={errors}
                                                                                control={control}
                                                                                priceRef={priceRef}
                                                                                comparePriceRef={comparePriceRef}
                                                                                packagingPriceRef={packagingPriceRef}
                                                                                gstOptions={gstOptions}
                                                                                quantityIdOptions={quantityIdOptions}
                                                                                setValue={setValue}
                                                                            />
                                                                        </>
                                                                    ) : null}
                                                                </EuiFlexItem>
                                                            );
                                                        })}
                                                    </>
                                                ) : (
                                                    <EuiCard title='Please Select an Ordering Mode to continue' />
                                                )}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <EuiSpacer />
                                        <EuiFlexGroup
                                            gutterSize='s'
                                            direction='row'
                                            justifyContent='flexStart'
                                            alignItems='flexStart'
                                            wrap
                                            responsive
                                        >
                                            <EuiFlexItem
                                                style={{
                                                    minWidth: 120,
                                                }}
                                            >
                                                <EuiFormRow
                                                    style={{
                                                        maxWidth: '150px',
                                                    }}
                                                    label={'price'}
                                                    error={errors['price'] ? errors['price'].message : ''}
                                                    isInvalid={errors['price']}
                                                >
                                                    <Controller
                                                        render={({ field }) => (
                                                            <EuiFieldNumber
                                                                value={field.value}
                                                                onChange={field.onChange}
                                                                disabled={isOutletMenu}
                                                                placeholder='Item price'
                                                            />
                                                        )}
                                                        name={'price'}
                                                        min={0}
                                                        step={'any'}
                                                        control={control}
                                                        inputRef={priceRef}
                                                        rules={{
                                                            required: 'Please enter item price',
                                                        }}
                                                        isInvalid={errors['price']}
                                                    />
                                                </EuiFormRow>
                                                <EuiText
                                                    size='s'
                                                    style={{
                                                        color: '#b8b9bd',
                                                    }}
                                                >
                                                    <span>Excluding All taxes</span>
                                                </EuiText>
                                            </EuiFlexItem>
                                            <EuiFlexItem
                                                style={{
                                                    minWidth: 120,
                                                }}
                                            >
                                                <EuiFormRow
                                                    style={{
                                                        minWidth: 120,
                                                    }}
                                                    label={'Compare Price'}
                                                >
                                                    <Controller
                                                        render={({ field }) => (
                                                            <EuiFieldNumber
                                                                value={field.value}
                                                                onChange={field.onChange}
                                                                placeholder='Item compare price'
                                                                disabled={isOutletMenu}
                                                            />
                                                        )}
                                                        name={'compare_price'}
                                                        min={0.0}
                                                        step={'any'}
                                                        control={control}
                                                        inputRef={comparePriceRef}
                                                    />
                                                </EuiFormRow>
                                            </EuiFlexItem>
                                            <EuiFlexItem
                                                style={{
                                                    minWidth: 120,
                                                }}
                                            >
                                                <EuiFormRow
                                                    style={{
                                                        minWidth: 120,
                                                    }}
                                                    label={'packaging'}
                                                >
                                                    <Controller
                                                        render={({ field }) => (
                                                            <EuiFieldNumber
                                                                value={field.value}
                                                                onChange={field.onChange}
                                                                placeholder='Item packaging charge'
                                                                disabled={isOutletMenu}
                                                            />
                                                        )}
                                                        name={'packaging_charge'}
                                                        min={0.0}
                                                        step={'any'}
                                                        control={control}
                                                        inputRef={packagingPriceRef}
                                                    />
                                                </EuiFormRow>
                                                <EuiText
                                                    size='s'
                                                    style={{
                                                        color: '#b8b9bd',
                                                    }}
                                                >
                                                    <span>Including All taxes</span>
                                                </EuiText>
                                            </EuiFlexItem>
                                            <EuiFlexItem
                                                style={{
                                                    minWidth: 120,
                                                }}
                                            >
                                                <EuiFormRow label='GST'>
                                                    <Controller
                                                        render={({ field }) => (
                                                            <EuiSelect
                                                                options={gstOptions}
                                                                value={field.value}
                                                                onChange={field.onChange}
                                                                disabled={isOutletMenu}
                                                            />
                                                        )}
                                                        name='gst_slab'
                                                        control={control}
                                                    />
                                                </EuiFormRow>
                                            </EuiFlexItem>
                                        </EuiFlexGroup>
                                        <EuiSpacer />
                                        <EuiFlexGroup
                                            gutterSize='s'
                                            direction='row'
                                            justifyContent='flexStart'
                                            alignItems='flexStart'
                                            wrap
                                            responsive
                                        >
                                            <EuiFlexItem>
                                                <TextField
                                                    label={`Quantity`}
                                                    name={'quantity'}
                                                    control={control}
                                                    defaultValue={watch('quantity')}
                                                    disabled={isOutletMenu}
                                                    errors={errors}
                                                    placeholder='Item Quantity'
                                                    style={{
                                                        minWidth: 120,
                                                    }}
                                                />
                                            </EuiFlexItem>
                                            <EuiFlexItem>
                                                <EuiFormRow
                                                    label={`Quantity Unit Id`}
                                                    style={{
                                                        minWidth: 120,
                                                    }}
                                                >
                                                    <Controller
                                                        render={({ field }) => {
                                                            return (
                                                                <EuiSuperSelect
                                                                    options={quantityIdOptions}
                                                                    valueOfSelected={field.value}
                                                                    onChange={field.onChange}
                                                                    disabled={isOutletMenu}
                                                                />
                                                            );
                                                        }}
                                                        name={'quantity_unit_id'}
                                                        min={0}
                                                        step={'any'}
                                                        control={control}
                                                        disabled={isOutletMenu}
                                                    />
                                                </EuiFormRow>
                                            </EuiFlexItem>
                                            <EuiFlexItem>
                                                <TextField
                                                    label={`Serves`}
                                                    name={'serves'}
                                                    control={control}
                                                    disabled={isOutletMenu}
                                                    errors={errors}
                                                    placeholder='Item Serves'
                                                    style={{
                                                        minWidth: 120,
                                                    }}
                                                />
                                            </EuiFlexItem>
                                            <EuiFlexItem>
                                                <TextField
                                                    label={`Serves Unit`}
                                                    name={'serves_unit'}
                                                    control={control}
                                                    disabled={isOutletMenu}
                                                    errors={errors}
                                                    placeholder='Item Serves Unit'
                                                    style={{
                                                        minWidth: 120,
                                                    }}
                                                />
                                            </EuiFlexItem>
                                            <EuiFlexItem>
                                                <EuiFormRow
                                                    style={{
                                                        minWidth: 120,
                                                    }}
                                                    label={`Calories`}
                                                >
                                                    <Controller
                                                        render={({ field }) => (
                                                            <EuiFieldNumber
                                                                value={field.value}
                                                                onChange={field.onChange}
                                                                placeholder='Eg. 450 Kcal'
                                                                append={'Kcal'}
                                                                disabled={isOutletMenu}
                                                            />
                                                        )}
                                                        name={'calories'}
                                                        control={control}
                                                        disabled={isOutletMenu}
                                                    />
                                                </EuiFormRow>
                                            </EuiFlexItem>
                                            <EuiFlexItem
                                                style={{
                                                    minWidth: 220,
                                                }}
                                            >
                                                <Controller
                                                    render={({ field }) => {
                                                        return (
                                                            <EuiFormRow label={`Allergens`}>
                                                                <EuiComboBox
                                                                    options={allergens}
                                                                    selectedOptions={field.value}
                                                                    onChange={(options) => {
                                                                        handleAllergensDeletion(options);
                                                                        field.onChange(options);
                                                                    }}
                                                                    placeholder='Select allergens'
                                                                    isDisabled={isOutletMenu}
                                                                />
                                                            </EuiFormRow>
                                                        );
                                                    }}
                                                    name={'allergens'}
                                                    control={control}
                                                />
                                            </EuiFlexItem>
                                        </EuiFlexGroup>
                                    </>
                                )}
                            </>
                        </EuiFlexGroup>
                    ) : null}

                    <EuiFlexItem style={{ margin: '10px 0' }}>
                        <EuiSpacer />
                        <EuiButton isDisabled={isOutletMenu} onClick={() => setVaraintModalState(true)}>
                            {!variantConditionForPrice() ? 'SEE VARIANTS' : 'ADD VARIANTS'}
                        </EuiButton>
                    </EuiFlexItem>
                </EuiFlexItem>
            </ItemDetailsCollaspibleNav>
        </>
    );
};

export default React.memo(ItemPricing);
